import React from 'react';

const GoogleTagManagerNoScript = () => {
  if (!process.env.TAG_MANAGER_URL_SUFFIX) {
    return null;
  }

  return (
    <noscript>
      <iframe
        src={`${process.env.TAG_MANAGER_URL}/ns.html?id=${process.env.TAG_MANAGER_ID}`}
        height="0"
        width="0"
        style={{ display: 'none', visibility: 'hidden' }}
        title="Google Tag Manager"
      ></iframe>
    </noscript>
  );
};

export default GoogleTagManagerNoScript;
